import React from "react";
import AuroraBackground from "./ui/AuroraBackground";
import { IconBrandLinkedin } from "@tabler/icons-react";

export function SimpleCenteredContactForm() {
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", e.target);
  };

  const socials = [
    {
      title: "linkedin",
      href: "https://www.linkedin.com/in/maria-mizamidou-4583a5a0/",
      icon: (
        <IconBrandLinkedin className="h-5 w-5 text-neutral-600 dark:text-neutral-400 hover:text-black" />
      )
    }
  ];

  return (
    <AuroraBackground className="flex justify-center items-center min-h-screen">
      <div className="bg-white dark:bg-neutral-950 rounded-3xl shadow-lg p-8 max-w-lg w-full space-y-4 z-10">
        <h1 className="text-2xl font-bold text-blue-900 dark:text-white">
          Contact Us
        </h1>
        <p className="text-blue-900 dark:text-neutral-400">
          Please reach out to us and we will get back to you at the speed of
          light.
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              htmlFor="name"
              className="block text-sm font-medium text-blue-900 dark:text-neutral-400"
            >
              Full Name
            </label>
            <input
              id="name"
              type="text"
              placeholder="Your Full Name"
              className="mt-1 block w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-blue-900  dark:text-neutral-400"
            >
              Email address
            </label>
            <input
              id="email"
              type="email"
              placeholder="hello@johndoe.com"
              className="mt-1 block w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label
              htmlFor="company"
              className="block text-sm font-medium text-blue-900  dark:text-neutral-400"
            >
              Company
            </label>
            <input
              id="company"
              type="text"
              placeholder="Your Company Name"
              className="mt-1 block w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label
              htmlFor="message"
              className="block text-sm font-medium text-blue-900  dark:text-neutral-400"
            >
              Message
            </label>
            <textarea
              id="message"
              rows={5}
              placeholder="Enter your message here"
              className="mt-1 block w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <button
            type="submit"
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black hover:bg-black/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black"
          >
            Submit
          </button>
        </form>
        <div className="flex items-center justify-center space-x-4 py-4">
          {socials.map((social) => (
            <a
              href={social.href}
              key={social.title}
              target="_blank"
              rel="noopener noreferrer"
            >
              {social.icon}
            </a>
          ))}
        </div>
      </div>
    </AuroraBackground>
  );
}

export default SimpleCenteredContactForm;
